import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useContainer } from '../../useContainer';
import { ActivityFeedWithUserDto } from '../../../commonTypes/project.types';
import { setCachedActivityFeed, selectCachedActivityFeed } from '../../../store/slices/projects.slice';
import { ACSApi } from '../../../api';

const useHttpGetActivityFeedWithUser = (projectId?: string) => {
    const acsApi: ACSApi = useContainer(ACSApi);

    const dispatch = useDispatch();
    const cachedData = useSelector(selectCachedActivityFeed(projectId || ''));
    const [activityFeed, setActivityFeed] = useState<ActivityFeedWithUserDto>();
    const [isActivityFeedReady, setIsActivityFeedReady] = useState<boolean>(false);

    const exec = (forceRefresh = false) => {
        if (projectId) {
            if (!forceRefresh && cachedData) {
                setActivityFeed(cachedData);
                setIsActivityFeedReady(true);
                return;
            }

            const { exec, abort } = acsApi.getActivityFeedWithUserData({
                params: { projectId },
                onSuccess: res => {
                    dispatch(setCachedActivityFeed({ projectId, data: res.body }));
                    setActivityFeed(res.body);
                },
                onError: error => console.log(error),
                onFinally: () => setIsActivityFeedReady(true),
            });
            exec();
            return abort;
        }
    };

    useEffect(() => {
        if (projectId) {
            if (cachedData) {
                setActivityFeed(cachedData);
                setIsActivityFeedReady(true);
                return;
            }

            exec();
        }
    }, [projectId, cachedData]);

    return { activityFeed, isActivityFeedReady, exec };
};

export default useHttpGetActivityFeedWithUser;
